import { Dispatch } from "redux";
import { MapDispatchToProps, MapStateToPropsFactory } from "react-redux";

import { BetslipSportsbookRemoveLegClick, UI__BETSLIP_SBK_REMOVE_LEG_CLICK } from "@ppb/tbd-store/actions/betslip";
import { BettingSportsbookRemoveLegAction, BETTING__SBK_REMOVE_LEG_ACTION } from "@ppb/tbd-store/actions/betting";
import { getSportsbookBettingLegs } from "@ppb/tbd-store/state/betting/sportsbook-betting/sportsbook-betting-selectors";
import { getBettingResolvers } from "../../../store/state/sportsbook-betting/betting-resolver";
import { createSportsbookBettingRunnerSelector } from "../../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { BetslipApplicationState } from "../../../store/state/BetslipApplicationState";
import {
  getBetslipPlaceStatus,
  getBetslipGroup,
  getSportsbookConfirmationLegs,
} from "../../../store/state/betslip-module/betslip-module-selectors";

import { createIsConfirmStep } from "../../sportsbook-betslip-confirm-mapper";
import { getSelectionTypeIcon } from "../../../helpers/selection-type";
import { buildSelection } from "../../connected-sportsbook-betslip-mapper";
import { ContainerProps, DispatchProps, StateProps } from "../props";

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getIsConfirmStep = createIsConfirmStep();
  const getSportsbookBettingRunner = createSportsbookBettingRunnerSelector();

  return (appState: BetslipApplicationState, { id, localization, capabilities }) => {
    const isConfirmStep = getIsConfirmStep(appState);
    const leg = isConfirmStep ? getSportsbookConfirmationLegs(appState)[id] : getSportsbookBettingLegs(appState)[id];

    if (!leg) {
      return { id, title: "", subtitle: "", action: "", odd: "" };
    }

    const group = getBetslipGroup(appState);
    const resolvers = getBettingResolvers(group);
    const bettingRunnersMetadata = resolvers.getMetadata(appState);
    const { runners } = leg;
    const [legRunnerId] = runners;
    const metadata = bettingRunnersMetadata[legRunnerId];
    const bettingRunner = getSportsbookBettingRunner(appState.betting.sportsbookBetting.runners, legRunnerId);

    const { title, subtitle, icon, silkFallbackType, meetingCountry, trap } = buildSelection(
      metadata,
      localization,
      bettingRunner,
      undefined,
      { hideEventName: true },
    );
    const placeStatus = getBetslipPlaceStatus(appState);
    const isPlacing = placeStatus === "INPROGRESS";

    return {
      urn: metadata.runnerUrn,
      id: leg.id,
      title,
      subtitle,
      isPlacing,
      odd: "",
      is90Min: metadata.is90Min,
      selectionTypeIcon: capabilities.selectionTypeIcon.enabled
        ? getSelectionTypeIcon(metadata.marketType, metadata.isSuperSub)
        : undefined,
      icon,
      silkFallbackType,
      meetingCountry,
      trap,
      isTrapIconEnabled: capabilities.trapIcon.enabled,
    };
  };
};

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, ContainerProps> = (dispatch: Dispatch) => ({
  dispatchSelectionRemove: (id: string, urn: string) => {
    dispatch<BetslipSportsbookRemoveLegClick>({
      type: UI__BETSLIP_SBK_REMOVE_LEG_CLICK,
      payload: { legId: id, runnerUrn: urn },
    });
    dispatch<BettingSportsbookRemoveLegAction>({
      type: BETTING__SBK_REMOVE_LEG_ACTION,
      payload: { legId: id },
    });
  },
});
